import logo from "@/assets/images/logo.png"
import util from "./util"
import axiosBuilder from 'axios'
import store from '@/store/index'
import router from '@/router/index'
import { Dialog } from 'vant'
import EncoderKit from "./EncoderKit"

const axios = axiosBuilder.create({
  timeout: 60000, // 请求超时时间
  baseURL: "/api",
})
// 添加请求拦截器
axios.interceptors.request.use(config => {
  let token = store.getters.token;
  if(token){
    config.headers.token=token.token;
  }
  let timestamp= new Date().getTime()
  let rand= Math.round(Math.random()*10000+10000)+"";
  var list = [timestamp,rand];
  if(token){
    list.push(token.token)
  }
  list.sort();            // 对 fruits 中的元素进行排序
  let sb="";
  for (let string of list) {
    sb+=string;
  }
  let signature = EncoderKit.encodeBySHA1(sb);
  config.headers.timestamp=timestamp;
  config.headers.signature=signature;
  config.headers.rand=rand;
  config.headers.customapp='mobile';
  return config
})


//将返回的数据进行克隆,并增加toString,让枚举可以字符串比较
let selfToString=function(){
    if(this.hasOwnProperty("$label")){
        return this.$label
    }
    // console.log("有调用",this.value)
    return this.value||JSON.stringify(this);//"[object object]"
}
let deepHandle=function(data){//
    var originQueue = [data];
    while(originQueue.length > 0){
        var _data = originQueue.shift();
        //_data有可能是数组
        if(Array.isArray(_data)){
            for(let item of _data){
                originQueue.push(item);
            }
        }else{
            if(typeof _data == 'object'){
                if(!_data)continue;
                // console.log("data",_data)
                if(_data.hasOwnProperty("$label")||_data.value){
                    _data.toString=selfToString;
                }
                for(var key in _data){
                    var _value = _data[key]
                    if(typeof _value == 'object'){
                        originQueue.push(_value);
                    }
                }
            }
        }
    }
};

// 添加响应拦截器
axios.interceptors.response.use(res => {
  // util.hideLoading();
  // console.log(res.data)
  let data = res.data
  if(res.data.logs && res.data.logs.length > 0){
    for(let item of res.data.logs){
      console.log(item);
    }
  }
  if (data.errcode == 0) {
      deepHandle(data.data)
    return Promise.resolve(data.data)
  }else if(data.errcode==401){
    // let ua = window.navigator.userAgent.toLowerCase()
    // let token = store.getters.token
    // if (ua.match(/MicroMessenger/i) == 'micromessenger' && store.getters.customerNumber && !token) {
    //   handlerWxLogin(ua);
    // }else{
    //   if(token){
    //     Dialog.alert({
    //       title: '登录态失效,即将跳转至登录界面',
    //       message: res.data.errmsg,
    //     }).then(() => {
    //       store.commit("logout")
    //     });
    //   }else{
    //     store.commit("logout")
    //   }
    // }
    let token = store.getters.token
    if(token){
      Dialog.alert({
        title: '登录状态失效,即将跳转至登录界面',
        message: res.data.errmsg,
        cancelButton:false
      }).then(() => {
        store.commit("logout")
      });
    }else{
      store.commit("logout")
    }
    return Promise.reject(data.errmsg)
  } else {
    return Promise.reject(data.errmsg)
  }
},error=>{
  // util.hideLoading();
  console.log("错误回调",error,error.code,error.message)
  let errmsg=error||"无法访问服务器,请检查网络异常";
  if(!error){
    errmsg="服务器异常"
  }else if (error.response) {
    errmsg="服务器异常,请联系管理员";//The request was made and the server responded with a status code
  } else if (error.request) {
    errmsg="请求超时,请稍后重试";//The request was made but no response was received
  }
  util.error(errmsg);
    return Promise.reject(errmsg);
  // return new Promise(()=>{})
})

axios.getUrl=(path)=>{
  return axios.defaults.baseURL+path;//axios.defaults.baseURL值为前纵/api
}

axios.getImageUrl=(path)=>{
  return axios.getUrl("/file/get?url="+encodeURIComponent(path));
}

axios.execute = (name, method, data) => {
  return axios.post('/entity/execute?c=' + name + '&e=' + method, data)
}
axios.exeQuery = (name, method, data) => {
  return axios.post('/entity/exeQuery?c=' + name + '&e=' + method, data)
}

axios.handleTask = (name, reqData) => {
  return axios.post('/lth/handleTask?c=' + name , reqData)
}
axios.cancelTask = (key) => {
  return axios.get('/lth/cancelTask' ,{params:{k:key}});
}
axios.taskProgress = (key) => {
  return axios.get('/lth/taskProgress' ,{params:{k:key}});
}

axios.reportData = (name, reqData) => {
  return axios.post('/ds/report?c=' + name , reqData)
}
axios.afterReportPrint = (name, reqData) => {
  return axios.post('/ds/afterReportPrint?c=' + name , reqData)
}
axios.afterExportPrint = (name, reqData) => {
  return axios.post('/ds/afterExportPrint?c=' + name , reqData)
}
axios.desc=(name,field)=>{
  return axios.get("/entity/desc?c="+name,{params:{field}});
}
axios.save=(clsname,data)=>{
  return axios.post("/entity/save?c="+clsname,data);
}
axios.editColumns=(clsname,data)=>{
  return axios.post("/entity/handleEditColumns?c="+clsname,data);
}
axios.delete=(clsname,keys)=>{
  let ids=[];
  if(Array.isArray(keys)){console.log("====")
    keys.map(item=>{
      ids.push(item.id||item)
    })
  }else{
    ids.push(keys.id||keys)
    console.log("----",ids)
  }
  return axios.post("/entity/delete?c="+clsname,ids);
}
axios.acd=(clsname,params)=>{//{page,rows,keyword}
  return axios.post("/ds/acd?c="+clsname,params);//{params:params}
}
axios.filter=(clsname,params)=>{//{page,rows,keyword}
  return axios.post("/entity/filter?c="+clsname,params);//{params:params}
}
axios.list=(clsname,data)=>{//{page:this.currentPage,rows:this.pageSize,paginate,extra,condition,countFields}
  return axios.post("/entity/list?c="+clsname,data);
}
axios.entity=(clsname,id)=>{
  return axios.get("/entity/get?c="+clsname+"&i="+id);
}
axios.first=(clsname,condition)=>{
  return axios.post("/entity/first?c="+clsname,condition);
}
axios.upload=(file)=>{
  const formData = new FormData()
  formData.append('file', file)
  return axios.post("/file/upload",formData)
}
axios.getAreaChildren=(parentId)=>{
    return axios.get("/region/children",{params:{parentId}});
}
// 不添加 baseURL 的 GET 请求方法
axios.rawGet = (url, config = {}) => {
    return axiosBuilder.get(url, config);
}

// function handlerWxLogin(ua){
//   let currParam = router.currentRoute.value.query
//
//   let type = ua.match(/wxwork/i) != 'wxwork'?'Wechat':'WxWork';
//   if(currParam.result){
//     console.log("~~~微信授权返回结果:",currParam)
//     userService.setOpenId(currParam.openId);
//     if(currParam.result == 'success'){
//       var params = {
//         type:type,
//         customerNumber:store.getters.customerNumber,
//         openId:currParam.openId
//       }
//       axios.post("/user/wxLogin",params).then(result=>{
//         this.$store.commit("setToken",result)
//         this.$router.replace("/index")
//       }).catch(e=>{
//         store.commit("logout")
//       })
//     }else{
//       store.commit("logout")
//     }
//   }else{
//     var params = {
//       type:type,
//       customerNumber:store.getters.customerNumber,
//       url:window.location.href
//     }
//     axios.post("/user/authorizeURL",params).then(result=>{
//       window.location.href = result;
//     }).catch(e=>{
//       store.commit("logout")
//     })
//   }
// }

export default axios;
